<template>
  <svg class="w-full h-full" viewBox="0 0 367 428" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1339_2713)">
  <path d="M355.117 54.7871H276.67V76.4066H332.342L276.67 137.45V152.711H291.853L346.26 92.9391V152.711H366.504V66.2327L355.117 54.7871Z" fill="#AEEDEA"/>
  <path d="M215.764 5.8252H-119.418V97.7079H118.453L-119.418 357.142V422H-54.544L177.921 167.971V422H264.42V54.469L215.764 5.8252Z" stroke="#AEEDEA" stroke-width="4.08338"/>
  </g>
  <defs>
  <clipPath id="clip0_1339_2713">
  <rect width="367" height="428" fill="white"/>
  </clipPath>
  </defs>
  </svg>
</template>
